<template>
  <div>
    <div class="header pt-2">
      <span class="ap-title ap-title__main">{{ $t('diagnosis.batchActionsModal.actionsTitle') }}</span>
    </div>
    <b-row>
      <b-col
        md="7"
        sm="8"
      >
        <b-row class="actions-btn">
          <b-col>
            <b-button
              qa="batchAction-preformated-button"
              class="btn__outline"
              size="sm"
              :class="{'active':isPreformatted}"
              block
              @click="$refs.preformattedModal.show()"
            >
              <i
                class="far fa-copy mr-2"
                aria-hidden="true"
              />{{ $t('diagnosis.batchActionsModal.preformated') }}
            </b-button>
          </b-col>
          <b-col>
            <b-button
              qa="batchAction-textTemplate-button"
              class="btn__outline"
              size="sm"
              :class="{'active':isTextTemplate}"
              block
              @click="$refs.textTemplatesModal.show()"
            >
              <i
                class="far fa-file-alt mr-2"
                aria-hidden="true"
              />{{ $t('diagnosis.batchActionsModal.textTemplate') }}
            </b-button>
          </b-col>
          <b-col>
            <b-button
              qa="batchAction-synopticTepmlate-button"
              class="btn__outline"
              size="sm"
              :class="{'active':isSynopticTemplate}"
              block
              @click="$refs.synopticTemplatesModal.show()"
            >
              <i
                class="far fa-file-edit mr-2"
                aria-hidden="true"
              />{{ $t('diagnosis.batchActionsModal.synopticTemplate') }}
            </b-button>
          </b-col>
          <b-col
            sm="12"
            md="1"
          >
            <b-button
              v-tooltip="$t('global.clean')"
              :disabled="!actionTypeSelected"
              qa="batchAction-clear-button"
              class="btn__icon btn__icon--primary  px-0"
              @click="clearActionView"
            >
              <i
                class="far fa-eraser"
                aria-hidden="true"
              />
            </b-button>
          </b-col>
        </b-row>
        <div
          v-if="isTextTemplate || isSynopticTemplate || isPreformatted"
          class="actionSelected d-flex mt-3"
        >
          <div class="d-flex align-items-center mr-4">
            <i
              class="far fa-check"
              aria-hidden="true"
            />
          </div>
          <div class="help d-flex flex-column">
            <span
              v-if="isPreformatted && preformattedData"
              class="dark"
            ><strong>{{ $t('diagnosis.batchActionsModal.preformated') }}: {{ preformattedData.title }}</strong></span>
            <span
              v-if="isTextTemplate"
              class="dark"
            ><strong>{{ $t('diagnosis.batchActionsModal.textTemplate') }}</strong></span>
            <span
              v-if="isSynopticTemplate"
              class="dark"
            ><strong>{{ $t('diagnosis.batchActionsModal.synopticTemplate') }}</strong></span>
            <span v-if="isPreformatted">{{ $t('diagnosis.batchActionsModal.preformatedHelp') }}</span>
            <span v-if="isTextTemplate || isSynopticTemplate">{{ $t('diagnosis.batchActionsModal.templatesHelp') }}</span>
          </div>
        </div>
        <div class="text-edition mt-3">
          <b-row v-if="!isTextTemplate && !isSynopticTemplate && !isPreformatted">
            <b-col>
              <div class="empty-action d-flex align-items-center justify-content-center">
                <div class="empty-section text-center">
                  <div class="pb-5">
                    <svg
                      id="batchActionsIcon"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <defs />
                      <title>batch</title>
                      <path
                        class="fill-svg-alternative"
                        d="M208,216a72,72,0,0,1,65.16,41.38L258.63,251l-6.45,14.64,38.37,16.92,16.93-38.37-14.65-6.45L287.4,250A88,88,0,0,0,121.77,270.4l15.69,3.2A72,72,0,0,1,208,216Z"
                      />
                      <path
                        class="fill-svg-alternative"
                        d="M208,360a72,72,0,0,1-65.16-41.38L157.37,325l6.45-14.64-38.37-16.92-16.93,38.37,14.65,6.45,5.46-12.38a88,88,0,0,0,165.6-20.3l-15.69-3.2A72,72,0,0,1,208,360Z"
                      />
                      <path
                        class="fill-svg-primary"
                        d="M176,0V48H128V96H80v48H48V400H0v64a48.05,48.05,0,0,0,48,48H320a48.05,48.05,0,0,0,48-48V144H96V112H400V400h16V96H144V64H448V352h16V48H192V16H496V304h16V0ZM48,496a32,32,0,0,1-32-32V416H272v48a47.86,47.86,0,0,0,12.25,32ZM352,160V464a32,32,0,0,1-64,0V400H64V160Z"
                      />
                    </svg>
                  </div>
                  <span class="tertiary-color">
                    {{ $t('diagnosis.batchActionsModal.emptyActionHelp') }}
                  </span>
                </div>
              </div>
            </b-col>
          </b-row>
          <!-- Preformatted area -->
          <b-row v-if="isPreformatted && preformattedData">
            <b-col>
              <b-tabs
                pills
                card
                vertical
                class="vt-tabs--vertical"
              >
                <b-tab active>
                  <template slot="title">
                    <i
                      class="far fa-align-justify"
                      aria-hidden="true"
                    />
                  </template>
                  <div class="ml-2">
                    <b-row class="d-flex align-items-center mt-3">
                      <b-col>
                        <span class="title primary-color">{{ $t('diagnosis.sections.macroscopy') }}</span>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="mt-2">
                        <vt-rich-text-editor
                          v-if="preformattedData.macro && preformattedData.macro.text"
                          :disabled="true"
                          class="mt-1 descriptionText"
                          :value="preformattedData.macro.text"
                          :autofocus="true"
                        />
                        <div
                          v-else
                          class="empty-section text-center"
                        >
                          <div class="py-3">
                            <i
                              class="fal fa-remove-format"
                              aria-hidden="true"
                            />
                          </div>
                          <span>
                            {{ $t('diagnosis.batchActionsModal.emptySection') }}
                          </span>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                </b-tab>
                <b-tab>
                  <template slot="title">
                    <i
                      class="fal fa-microscope"
                      aria-hidden="true"
                    />
                  </template>
                  <div class="ml-2">
                    <b-row class="d-flex align-items-center mt-3">
                      <b-col>
                        <span class="title primary-color">{{ $t('diagnosis.sections.microscopy') }}</span>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="mt-2">
                        <vt-rich-text-editor
                          v-if="preformattedData.micro && preformattedData.micro.text"
                          :disabled="true"
                          class="mt-1 descriptionText"
                          :value="preformattedData.micro.text"
                          :autofocus="true"
                        />
                        <div
                          v-else
                          class="empty-section text-center"
                        >
                          <div class="py-3">
                            <i
                              class="fal fa-remove-format"
                              aria-hidden="true"
                            />
                          </div>
                          <span>
                            {{ $t('diagnosis.batchActionsModal.emptySection') }}
                          </span>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                </b-tab>
                <b-tab>
                  <template slot="title">
                    <i
                      class="fal fa-comment-alt-medical"
                      aria-hidden="true"
                    />
                  </template>
                  <div class="ml-2">
                    <b-row class="d-flex align-items-center mt-3">
                      <b-col>
                        <span class="title primary-color">{{ $t('diagnosis.sections.diagnosis') }}</span>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="mt-2">
                        <vt-rich-text-editor
                          v-if="preformattedData.diagnosis && preformattedData.diagnosis.text"
                          :disabled="true"
                          class="mt-1 descriptionText"
                          :value="preformattedData.diagnosis.text"
                          :autofocus="true"
                        />
                        <div
                          v-else
                          class="empty-section text-center"
                        >
                          <div class="py-3">
                            <i
                              class="fal fa-remove-format"
                              aria-hidden="true"
                            />
                          </div>
                          <span>
                            {{ $t('diagnosis.batchActionsModal.emptySection') }}
                          </span>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                </b-tab>
                <b-tab>
                  <template slot="title">
                    <i
                      class="fal fa-files-medical"
                      aria-hidden="true"
                    />
                  </template>
                  <div class="ml-2">
                    <b-row class="d-flex align-items-center mt-3">
                      <b-col>
                        <span class="title primary-color">{{ $t('diagnosis.sections.additionalReport') }}</span>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="mt-2">
                        <vt-rich-text-editor
                          v-if="preformattedData.additionalReport && preformattedData.additionalReport.text"
                          :disabled="true"
                          class="mt-1 descriptionText"
                          :value="preformattedData.additionalReport.text"
                          :autofocus="true"
                        />
                        <div
                          v-else
                          class="empty-section text-center"
                        >
                          <div class="py-3">
                            <i
                              class="fal fa-remove-format"
                              aria-hidden="true"
                            />
                          </div>
                          <span>
                            {{ $t('diagnosis.batchActionsModal.emptySection') }}
                          </span>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                </b-tab>
                <b-tab>
                  <template slot="title">
                    <i
                      class="fal fa-project-diagram"
                      aria-hidden="true"
                    />
                  </template>
                  <div class="ml-2">
                    <b-row class="d-flex align-items-center mt-3">
                      <b-col>
                        <span class="title primary-color">{{ $t('diagnosis.sections.codifications') }}</span>
                      </b-col>
                    </b-row>
                    <div v-if="preformattedData.codifications && preformattedData.codifications.length">
                      <b-row class="mt-2 mb-3 header-row">
                        <b-col class="filter-label">
                          {{ $t('diagnosis.labels.topographic') }}
                        </b-col>
                        <b-col class="filter-label">
                          {{ $t('diagnosis.labels.morphological') }}
                        </b-col>
                      </b-row>
                      <b-row
                        v-for="codification in preformattedData.codifications"
                        :key="codification.id"
                        class="codifications-row"
                      >
                        <b-col
                          v-if="codification.topographicCode"
                          class="label-dark"
                        >
                          {{ codification.topographicCode.description }} - {{ codification.topographicCode.code }}
                        </b-col>
                        <b-col
                          v-if="codification.morphologicCode"
                          class="label-dark"
                        >
                          {{ codification.morphologicCode.description }} - {{ codification.morphologicCode.code }}
                        </b-col>
                        <b-col cols="12">
                          <div class="horizontal-divider my-2" />
                        </b-col>
                      </b-row>
                    </div>
                    <div
                      v-else
                      class="empty-section text-center"
                    >
                      <div class="py-3">
                        <i
                          class="fal fa-remove-format"
                          aria-hidden="true"
                        />
                      </div>
                      <span>
                        {{ $t('diagnosis.batchActionsModal.emptySection') }}
                      </span>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
          <!-- Template area -->
          <b-row v-if="isTextTemplate || isSynopticTemplate">
            <b-col>
              <div class="no-tabs-area">
                <vt-rich-text-editor
                  :disabled="true"
                  class="mt-1 descriptionText"
                  :value="templateData.text"
                  :autofocus="true"
                />
              </div>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col cols="auto">
        <div class="vertical-line" />
      </b-col>
      <b-col>
        <div>
          <span class="ap-title ap-title__section"><i
            class="far fa-user-friends mr-2"
            aria-hidden="true"
          />{{ $t('diagnosis.batchActionsModal.responsiblesTitle') }}</span>
          <div class="mt-3">
            <div class="form-label">
              <label>
                {{ $t('diagnosis.batchActionsModal.administrative') }}
              </label>
            </div>
            <vt-combo-select
              v-model="updateCaseData.administrative"
              track-by="id"
              :option-loader="getPersonnelAdministrative"
              label="fullName"
            />
          </div>
          <div class="mt-3">
            <div class="form-label d-flex flex-column">
              <label>
                {{ $t('diagnosis.batchActionsModal.nonPathologistSpecialist') }}
              </label>
              <span
                v-if="selectedElementsContainCases"
                class="warning-message"
              >{{ $t('diagnosis.batchActionsModal.applyToAllSamples') }}</span>
            </div>
            <vt-combo-select
              v-model="updateCaseData.specialist"
              :option-loader="getPersonnelCytologyExpert"
              track-by="id"
              class="nowrap"
              label="fullName"
            />
          </div>
          <div class="mt-3">
            <div class="form-label">
              <label>
                {{ $t('diagnosis.batchActionsModal.resident') }}
              </label>
            </div>
            <vt-combo-select
              v-model="updateCaseData.resident"
              track-by="id"
              :option-loader="getPersonnelResident"
              label="fullName"
            />
          </div>
          <div class="mt-3">
            <div class="form-label">
              <label>
                {{ $t('diagnosis.batchActionsModal.pathologist') }}
              </label>
            </div>
            <vt-combo-select
              id="pathologistId"
              v-model="updateCaseData.pathologist"
              track-by="id"
              :option-loader="getPersonnelPathologist"
              label="fullName"
              name="pathologistId"
            />
          </div>
        </div>
        <div class="mt-5">
          <span class="ap-title ap-title__section"><i
            class="far fa-chart-network mr-2"
            aria-hidden="true"
          />{{ $t('diagnosis.batchActionsModal.casesTitle') }}</span>
          <div class="switch-btn mt-3 p-0 d-flex align-items-md-center align-items-sm-start flex-md-row flex-sm-column mb-sm-3 mb-md-0">
            <input
              id="toggleInform"
              v-model="updateCaseData.markCasesAsInformed"
              class="offscreen"
              type="checkbox"
              aria-hidden="true"
              @change="onInformOrTranscribeChange(true)"
            >
            <label
              for="toggleInform"
              class="switch mb-0"
            />
            <span class="ml-3 dark">{{ $t('diagnosis.batchActionsModal.markCasesAsInformed') }}</span>
          </div>
          <div
            v-if="transcriptionRequiredActivated"
            class="switch-btn mt-1 p-0 d-flex align-items-md-center align-items-sm-start flex-md-row flex-sm-column"
          >
            <input
              id="toggleTranscription"
              v-model="updateCaseData.markCasesAsInformedAndTranscribed"
              class="offscreen"
              type="checkbox"
              aria-hidden="true"
              @change="onInformOrTranscribeChange(false)"
            >
            <label
              for="toggleTranscription"
              class="switch mb-0"
            />
            <span class="ml-3 dark">
              {{ $t('diagnosis.batchActionsModal.markCasesAsInformedAndTranscribed') }}
            </span>
          </div>
        </div>
      </b-col>
    </b-row>
    <modal-wrapper ref="preformattedModal">
      <preformatted-modal
        for-batch-actions-modal
        @preformattedSelected="onPreformattedSelected($event)"
      />
    </modal-wrapper>
    <modal-wrapper ref="textTemplatesModal">
      <text-templates-modal
        :laboratory-id="laboratoryId"
        :for-batch-actions-modal="true"
        @templateSelected="onTextTemplateSelected($event)"
      />
    </modal-wrapper>
    <modal-wrapper ref="synopticTemplatesModal">
      <synoptic-templates-modal
        :laboratory-id="laboratoryId"
        @templateSelected="onSynopticTemplateSelected($event)"
      />
    </modal-wrapper>
  </div>
</template>

<script>
import PreformattedModal from '@/modules/diagnosisModule/views/form/modals/PreformattedModal'
import TextTemplatesModal from '@/components/description/TextTemplatesModal'
import SynopticTemplatesModal from '@/modules/diagnosisModule/views/form/modals/SynopticTemplatesModal'
import { personnelService } from '@/api/resources/personnelService'
import parameterService from '@/api/resources/parameterService'
import { CommonResponsibilityCodeEnum } from '@/api/services/common/responsibility/common-responsibility.dto'
import { DiagnosisBatchActionType } from '@/modules/diagnosisModule/components/BatchActionsModal/batch-actions.model'

export default {
    name: 'ActionsSelectionView',
    components: { PreformattedModal, SynopticTemplatesModal, TextTemplatesModal },
    props: {
        selectedElements: { type: Array }
    },
    data() {
        return {
            updateCaseData: {
                administrative: null,
                pathologist: null,
                resident: null,
                specialist: null,
                markCasesAsInformed: false,
                markCasesAsInformedAndTranscribed: false
            },
            selected: null,
            preformattedData: null,
            templateData: null,
            actionTypeSelected: null,
            transcriptionRequiredActivated: false
        }
    },
    computed: {
        laboratoryId() {
            return this.$store.getters.labId
        },
        isPreformatted() {
            return this.actionTypeSelected === DiagnosisBatchActionType.PREFORMATTED
        },
        isTextTemplate() {
            return this.actionTypeSelected === DiagnosisBatchActionType.TEXT_TEMPLATE
        },
        isSynopticTemplate() {
            return this.actionTypeSelected === DiagnosisBatchActionType.SYNOPTIC_TEMPLATE
        },
        selectedElementsContainCases() {
            return this.selectedElements.some(element => element.caseNumber)
        }
    },
    async created() {
        const [err, response] = await this.toCall(parameterService.findCaseTranscriptionRequired(this.laboratoryId))
        if (err) {
            this.showErrorModalGlobal()
        }
        this.transcriptionRequiredActivated = response
    },
    methods: {
        onInformOrTranscribeChange(informMarked) {
            if (informMarked) {
                this.updateCaseData.markCasesAsInformedAndTranscribed = false
            } else {
                this.updateCaseData.markCasesAsInformed = false
            }
        },
        onPreformattedSelected(preformattedData) {
            this.actionTypeSelected = DiagnosisBatchActionType.PREFORMATTED
            this.preformattedData = preformattedData
            this.$emit('selected', preformattedData)
        },
        onTextTemplateSelected(textTemplateData) {
            this.actionTypeSelected = DiagnosisBatchActionType.TEXT_TEMPLATE
            this.templateData = textTemplateData
            this.$emit('selected')
        },
        onSynopticTemplateSelected(synopticTemplateData) {
            this.actionTypeSelected = DiagnosisBatchActionType.SYNOPTIC_TEMPLATE
            this.templateData = synopticTemplateData
            this.$emit('selected')
        },
        async getPersonnelPathologist() {
            return personnelService.getPersonnelByLaboratoryAndResponsibility(this.laboratoryId, CommonResponsibilityCodeEnum.PATHOLOGIST)
        },
        async getPersonnelResident() {
            return personnelService.getPersonnelByLaboratoryAndResponsibility(this.laboratoryId, CommonResponsibilityCodeEnum.RESIDENT)
        },
        async getPersonnelAdministrative() {
            return personnelService.getPersonnelByLaboratoryAndResponsibility(this.laboratoryId, CommonResponsibilityCodeEnum.ADMINISTRATIVE)
        },
        getPersonnelCytologyExpert() {
            return personnelService.getPersonnelByLaboratoryAndResponsibility(this.laboratoryId, CommonResponsibilityCodeEnum.CYTOLOGY_EXPERT)
        },
        clearActionView() {
            this.actionTypeSelected = null
            this.$emit('clearActionView')
        }
    }
}
</script>

<style scoped>

</style>
